/**
 * The monitoring screens' route paths, kept beside the `routes.ts` that
 * registers them so a caller elsewhere derives the URL from the same literal.
 *
 * Relative to the router's `basepath`, like every other route literal in this
 * plane. Chosen here: neither the spec nor Figma names a URL for these
 * screens.
 */

import { interpolatePath } from '@tanstack/react-router';

export const MONITORING_PATH = '/c/$campaignId/monitoring';
export const AGENDA_PATH = '/c/$campaignId/monitoring/agenda';
export const FAILURES_PATH = '/c/$campaignId/monitoring/failures';

export function monitoringPath(campaignId: string): string {
  return interpolatePath({ path: MONITORING_PATH, params: { campaignId } }).interpolatedPath;
}
